import { isYoutubeNativeStation } from '../helpers';
import { useActiveStation } from './useActiveStation';

/** Returns whether the currently active station uses the YouTube Native integration. */
export function useIsActiveStationYoutubeNative() {
  return isYoutubeNativeStation(useActiveStation());
}
